import { useReducer } from "react";

import CabinetContext from "./cabinet-context";

const defaultCabinetState = {
  items: [],
};

const cabinetReducer = (state, action) => {

  // add ingredient to cabinet
  if (action.type === "ADD") {

    // check if ingredient is already in cabinet
    const existingCabinetItemIndex = state.items.findIndex(
      (item) => item.id === action.item.id
    );
    const existingCabinetItem = state.items[existingCabinetItemIndex];

    var updatedItems;
    var updatedItem;

    // existingCabinetItem will be undefined if not already in cabinet
    if (existingCabinetItem) {
      const newVolume = Math.min(existingCabinetItem.volume + action.item.volume, 9999); // max ingredient volume is 9999
      updatedItem = {
        ...existingCabinetItem,
        volume: newVolume,
      };
      updatedItems = [...state.items];
      updatedItems[existingCabinetItemIndex] = updatedItem;
    } else {
      updatedItems = state.items.concat(action.item);
    }
    return {
      items: updatedItems,
    };
  }

  // remove item from cabinet
  if (action.type === "REMOVE") {
    const updatedItems = state.items.filter((item) => item.id !== action.id);
    return {
      items: updatedItems,
    };
  }

  // clear cabinet
  if (action.type === "CLEAR") {
    const updatedItems = [];

    return {
      items: updatedItems,
    };
  }
  // save cabinet to local storage
  if (action.type === "SAVE") {
    localStorage.setItem('cabinetItems', JSON.stringify(state.items))
    return {
      items: state.items,
    };
  }
};


const CabinetProvider = (props) => {
  const cabinetItems = JSON.parse(localStorage.getItem("cabinetItems"));

  if(cabinetItems){
    defaultCabinetState.items = cabinetItems
  }

  const [cabinetState, dispatchCabinetAction] = useReducer(
    cabinetReducer,
    defaultCabinetState
  );

  const addItemToCabinetHandler = (item) => {
    dispatchCabinetAction({ type: "ADD", item: item });
  };

  const removeItemFromCabinetHandler = (id) => {
    dispatchCabinetAction({ type: "REMOVE", id: id });
  };

  const clearCabinetHandler = () => {
    dispatchCabinetAction({ type: "CLEAR" });
  };

  const saveCabinetHandler = () => {
    dispatchCabinetAction({ type: "SAVE" });
  };


  const cabinetContext = {
    items: cabinetState.items,
    addItem: addItemToCabinetHandler,
    removeItem: removeItemFromCabinetHandler,
    clearCabinet: clearCabinetHandler,
    saveCabinet: saveCabinetHandler,
  };


  return (
    <CabinetContext.Provider value={cabinetContext}>
      {props.children}
    </CabinetContext.Provider>
  );
};

export default CabinetProvider;
